import React, { useEffect, useState } from "react";
import { Paper, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { Skeleton } from "@material-ui/lab";

const TutorialVideos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const PLAYLIST_ID = "PLu0W_9lII9agx66oZnT6IyhcMIbUMNMdt";
  const API_KEY = "AIzaSyApvGRgigy4RDB_qKMFaY_Dfx77b8W0OVA";

  const PER_PAGE = 10;
  const count = Math.ceil(videos.length / PER_PAGE);
  const _DATA = usePagination(videos, PER_PAGE); // custom hook
  const [page, setPage] = useState(1);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    fetchVideos("");
  }, []);

  const fetchVideos = async (token = "") => {
    setLoading(true);
    try {
      let allVideos = [];
      let nextPageToken = "";
      while (true) {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${PLAYLIST_ID}&key=${API_KEY}&pageToken=${nextPageToken}`
        );
        const data = await response.json();
        allVideos = [...allVideos, ...data.items];
        if (!data.nextPageToken) break;
        nextPageToken = data.nextPageToken;
      }
      setVideos(allVideos);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch YouTube playlist:", error);
      setLoading(false);
    }
  };

  function usePagination(data, itemsPerPage) {
    const [currentPage, setCurrentPage] = useState(1);
    const maxPage = Math.ceil(data.length / itemsPerPage);

    function currentData() {
      const begin = (currentPage - 1) * itemsPerPage;
      const end = begin + itemsPerPage;
      return data.slice(begin, end);
    }

    function jump(page) {
      const pageNumber = Math.max(1, Math.min(page, maxPage));
      setCurrentPage(pageNumber);
    }

    return { currentData, jump, currentPage, maxPage };
  }

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <Typography variant="h5" component="h3">
          Tutorial Videos
        </Typography>

        <div className="row">
          {loading
            ? Array.from(new Array(6)).map((_, index) => (
                <div className="col-md-6 mb-4" key={index}>
                  <div className="card m-5 p-5">
                    <Skeleton variant="rectangular" height={250} />
                    <div className="card-body">
                      <Skeleton variant="text" height={30} width="80%" />
                      <Skeleton variant="text" height={20} width="60%" />
                    </div>
                  </div>
                </div>
              ))
            : _DATA.currentData().map((video) => (
                <div
                  className="col-md-6 col-sm-12 mb-4"
                  key={video.snippet.resourceId.videoId}
                >
                  <div className="card m-5 p-5">
                    <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                      frameBorder="0"
                      allowFullScreen
                      title={video.snippet.title}
                    ></iframe>
                    <div className="card-body">
                      <h5 className="card-title">{video.snippet.title}</h5>
                      <p className="card-text text-muted">
                        {video.snippet.description?.substring(0, 100)}...
                      </p>
                    </div>
                  </div>
                </div>
              ))}
        </div>

        <Pagination
          color="text-primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />
      </Paper>
    </div>
  );
};

export default TutorialVideos;
